import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CODIGO' htmlFor='input-codigo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputText disabled id='input-codigo' name='input-codigo' defaultValue={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
